import React, { useState, useCallback, useEffect, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import Cropper from 'react-easy-crop'
import getCroppedImg from '../utils/cropImage'
import ButtonAction from './ButtonAction'

const EasyCrop = ({ image, imageData, setImage }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [newCroppedAreaPixels, setNewCroppedAreaPixels] = useState(null)
  const [visible, setVisible] = useState(true)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setNewCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const createCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        newCroppedAreaPixels,
        imageData?.type,
        { width: 450, height: 450 }
      )
      const finalImg = { ...imageData }
      delete finalImg.original
      finalImg.base64 = croppedImage.base64.split('base64,').pop()
      finalImg.blob = croppedImage.blob
      setImage(finalImg)
    } catch (e) {
      console.error(e)
    }
  }, [newCroppedAreaPixels])

  useEffect(() => {
    setVisible(true)
  }, [image])

  return (
    image && (
      <Transition.Root show={visible} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {
            setVisible(false)
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-md bg-sec-grey-3 p-6 text-left shadow-xl transition-all sm:my-8">
                  <div className="relative w-[300px] h-[300px] lg:w-[400px] lg:h-[400px]">
                    <Cropper
                      image={image}
                      crop={crop}
                      zoom={zoom}
                      zoomSpeed={4}
                      maxZoom={3}
                      aspect={1 / 1}
                      zoomWithScroll={true}
                      showGrid={true}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      cropShape="round"
                      onCropComplete={onCropComplete}
                      objectFit="contain"
                    />
                  </div>
                  <ButtonAction
                    text="Guardar"
                    type="submit"
                    className="mt-4"
                    size="small"
                    handleChange={() => {
                      createCroppedImage()
                      setVisible(false)
                    }}
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
  )
}

export default EasyCrop
